import VueRouter from "vue-router"

const router = new VueRouter({
    routes: [
        {
            path: '/',
            component: () => import('@/views/home/index')
        },
        {
            path: '/data',
            component: () => import('@/views/data/index')
        }
    ]
})

export default router
